// removed by extract-text-webpack-plugin
module.exports = {"Form_wrap":"UpdateChild__Form_wrap__25BgN","Form_group":"UpdateChild__Form_group__2oIVO","ContainerBtn":"UpdateChild__ContainerBtn__pjz3F","Btn":"UpdateChild__Btn__3I3Kt","RedBtn":"UpdateChild__RedBtn__1cwUZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChildController/UpdateChild/UpdateChild.css
// module id = 121
// module chunks = 0